import React from 'react';
import { RemovePlanForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

export type RemovePlanModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemovePlanModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Remove plan'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <RemovePlanForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
